import './whatYouLearn.css';

function WhatYouLearn({ book }) {
  const bgColor = book.bgColor || '#2c346b';
  const titleColor = book.titleColor || '#fff559';
  const textColor = book.textColor || '#ffffff';

  return (
    <section
      className="what-you-learn"
      style={{ backgroundColor: bgColor }}
    >
      <h2 className="learn-title" style={{ color: titleColor }}>
        {book.learnTitle || "What You Learn in This Book"}
      </h2>
      <div className="learn-content">
  {book.learnContent.map((column, index) => (
    <ul key={index} className="learn-list">
      {column.map((item, i) => (
        <li
          key={i}
          style={{
            color: book.textColor,      
          }}
        >
          {item}
        </li>
      ))}
    </ul>
  ))}
</div>
      {book.learnMoreText && (
        <p className="more-text" style={{ color: textColor }}>
          {book.learnMoreText}
        </p>
      )}
    </section>
  );
}

export default WhatYouLearn;
